import { useInfiniteQuery, useQuery } from '@tanstack/react-query';
import { axiosInstance, FilteringSortingParams, VideoDetailsType } from '../../utils';

export interface AvatarVideosResponse {
  data: VideoDetailsType[];
  count: number;
}
export const getAllAvatarCreatedVideos = async ({
  page = 1,
  limit = 20,
  sortBy = 'updatedAt',
  sortOrder = 'desc',
  filters = {},
}: FilteringSortingParams, name?: string): Promise<AvatarVideosResponse> => {
  const searchParams = new URLSearchParams();

  if (page) searchParams.append('page', page.toString());
  if (limit) searchParams.append('limit', limit.toString());
  if (sortBy) searchParams.append('sortBy', sortBy);
  if (sortOrder) searchParams.append('sortOrder', sortOrder);
  if (name) searchParams.append('name', name);

  Object.entries(filters).forEach(([key, value]) => {
    if (value) {
      searchParams.append(`filters[${key}]`, value);
    }
  });

  const res = await axiosInstance.get(`/api/videos/all?${searchParams.toString()}`);
  return res.data;
};

export const useGetAllAvatarCreatedVideos = (params?: FilteringSortingParams, name?: string) => {
  return useInfiniteQuery(
    ['getAllAvatarCreatedVideos', params, name],
    ({ pageParam = 1 }) => getAllAvatarCreatedVideos({ ...params, page: pageParam }, name),
    {
      getNextPageParam: (lastPage, allPages) => {
        const currentPage = allPages.length;
        const totalItemsFetched = currentPage * (params?.limit ?? 20);

        if (totalItemsFetched < lastPage.count) {
          return currentPage + 1;
        } else {
          return undefined;
        }
      },
    }
  );
};
